import { InvoiceModel } from "./InvoiceModel";

export class GateInModel {
  GateInId: number = 0;
  VehicleId: number = 0;
  TransportCompanyName: string = '';
  VehicleNumber: string = '';
  VehicleType: string = '';
  SupplierId: number = 0;
  SupplierName: string = '';
  InvoiceId: number = 0;
  GateIn: boolean = false;
  GateInDate: string = '';
  GateInPersonContact: string = '';
  GateInPerson: string = '';
  GatePassIssue: boolean = false;
  GatePassIssueDate: string = '';
  GateOut: boolean = false;
  GateOutDate: string = '';
  AddedBy: string = '';
  GatePassAddedBy: string = '';
  GatePassAddedByName: string = '';
  GateOutAddedBy: string = '';
  AddedDate: string = '';
  Invoice: InvoiceModel[] = [];
  SaleOrderId: number[] = [];
  Type!: string;
  InWeight: string = '';
  OutWeight: string = '';
  IsOutpassRequired: string = '';
  Cancelled?: boolean;
  CancelledAt?: string;
  CancelledBy?: string;
  CancelReason?: string;
  LinkedOutpasses?: LinkedOutpassModel[];
  LinkedDispatches?: LinkedDispatchModel[];
  /**
   * Set by `gate/getvehiclestatus` when the open gate-in it returns is older than the
   * configured reuse window (`GateInReuseWindowHours`) — i.e. it is very likely an
   * unrelated, never-closed visit rather than the vehicle's current one. Optional and
   * defensively treated as absent/false until the backend change that adds it ships.
   */
  IsStale?: boolean;
}

export interface LinkedOutpassModel {
  OutpassId: number;
  OutpassNumber: string;
  Status: string;
}

export interface LinkedDispatchModel {
  JumboDispatchId: number;
  DispatchNumber: string;
  PackingNumber: string;
  DispatchStatus: string;
}


export class GateInPrintModel {
  VehicleNumber: string = '';
  TransportCompanyName: string = '';
  GateInPerson: string = '';
  GateInPersonContact: string = '';
  GateInDate: string = '';
  GatePassIssueDate: string = '';
  GateOutDate: string = '';
  AddedBy: string = '';
  GateIn: string = '';
  GatePassIssue: string = '';
  GateOut: string = '';


}
